// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"signUp_wrapper__YM2z2","signin":"signUp_signin__UScYO","signinButton":"signUp_signinButton__BlKQl"};